//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

  data() {
    return {
      poster:'',
      src:'',
      videoType:'',
      newsId:''
    };
  },
  methods: {
    black(){
      this.$router.go(-1);

    },
  },
  mounted () {
    this.poster = this.$route.query.poster;
    this.src = this.$route.query.src;
    this.newsId = this.$route.query.newsId;
  },
};





// WEBPACK FOOTER //
// ./src/pages/qf/live_video_detail.vue